/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_HeadingInputs */

const en_wb_marketing_heading = /** @type {(inputs: Wb_Marketing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More visits. A quieter enquiry form.`)
};

const lv_wb_marketing_heading = /** @type {(inputs: Wb_Marketing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vairāk apmeklējumu. Klusāka pieteikuma forma.`)
};

/**
* | output |
* | --- |
* | "More visits. A quieter enquiry form." |
*
* @param {Wb_Marketing_HeadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_heading = /** @type {((inputs?: Wb_Marketing_HeadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_HeadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_heading(inputs)
	return en_wb_marketing_heading(inputs)
});